import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {


  url = environment.serverAPI9 + "/api/posCategories";
  ur2 = environment.serverAPI9 + "/api";


  constructor(private http: HttpClient,
    private loginService: LoginService
  ) { }

  getCategoris(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCategories(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCategoriesDropDown(): Observable<Object> {

    return this.http.get(`${this.url}/dropdown`);
  }

  getAllCategoriesDropDownUnauthorized(): Observable<Object> {
    return this.http.get(`${this.url}/ig/dropdown`);
  }


  saleCategory() {
    return this.http.get(`${this.url}/sub`);

  }


  getCategoriesById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  getAllParentChildDropDown(id: number): Observable<Object> {
    return this.http.get(`${this.url}/parent/${id}`);
  }

  getAllParentDropDown() {
    return this.http.get(`${this.url}/parent/dropdown`);
  }

  addOrEditCategories(categories: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, categories);
  }

  categoriesSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  downloadCategoriesTemplate(): Observable<any> {
    return this.http.get(`${this.ur2}/posCategories/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  getAllCategoryDropDown() {
    return this.http.get(`${this.url}/dropdown`);
  }


  deleteByCategoriesId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }


  downloadCategoryReport(Page: number, size: number, sort, selectionCategories): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
      &size=${size}&sort=${sort}`, selectionCategories, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  categoriesNameVerified(name: any): Observable<Object> {
    return this.http.get(`${this.url}/name/${name}`);
  }
}
